import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import SalaryList from '../salaryList/AllSalary';
import SalaryDetails from '../salaryDetail/index';
import Payroll from '../payroll';

import { SalaryProvider } from '../context/salaryContext';

function SalaryRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"HEREEEEEEE")

  return (
    <SalaryProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>   
       <Route index element={<SalaryList />} />      {/*  Matches `/salary` */}
       <Route path=":id" element={<SalaryDetails />} />  {/* Matches `/salary/:id` */}
       <Route path="/payroll" element={<Payroll />} />      {/*  Matches `/salary` */}

      </Route>
    </Routes>
    </SalaryProvider>
  );
}

export default SalaryRouter;
